import { render, staticRenderFns } from "./WorkshopsBookingDetails.vue?vue&type=template&id=72f2ab4a&scoped=true&"
import script from "./WorkshopsBookingDetails.vue?vue&type=script&lang=ts&"
export * from "./WorkshopsBookingDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f2ab4a",
  null
  
)

export default component.exports